import React, { useEffect, useState } from "react";
import axios from "axios";
import swal from "sweetalert";

// Danh sách toàn bộ mã sảnh game hiện có trên hệ thống
const PROVIDERS = [
    { code: "4", name: "AG" },
    { code: "79", name: "BBIN" },
    { code: "104", name: "CMD" },
    { code: "16", name: "CQ9" },
    { code: "27", name: "DG" },
    { code: "86", name: "Evolution" },
    { code: "142", name: "FB" },
    { code: "140", name: "JILI" },
    { code: "121", name: "KingMaker" },
    { code: "102", name: "V8 Poker" },
    { code: "123", name: "King Poker" },
    { code: "43", name: "MG" },
    { code: "39", name: "PP" },
    { code: "174", name: "SABA" },
    { code: "54", name: "SBO" },
    { code: "151", name: "UG" },
    { code: "118", name: "WM" },
    { code: "99", name: "TF" },
    { code: "112", name: "SEXY" },
    { code: "111", name: "Playtech" },
    { code: "28", name: "Allbet" },
    { code: "55", name: "JDB" },
    { code: "202", name: "WS168" },
    { code: "61", name: "IMES" },
    { code: "132", name: "SV388" }
];

function Transfer({ profile, getProfile }) {
    const [localProfile, setLocalProfile] = useState(profile);
    const [lobbies, setLobbies] = useState(
        PROVIDERS.map(p => ({ ...p, balance: 0, status: 'loading' }))
    );
    const [isGlobalLoading, setIsGlobalLoading] = useState(false);

    // Cấu hình Axios Interceptor gửi kèm token
    useEffect(() => {
        const interceptor = axios.interceptors.request.use(
            (config) => {
                const token = localStorage.getItem("user");
                if (token) {
                    config.headers["Authorization"] = `Bearer ${token}`;
                }
                return config;
            },
            (error) => {
                return Promise.reject(error);
            }
        );

        // Quét số dư tất cả sảnh game khi component mount
        fetchAllBalances();

        return () => {
            axios.interceptors.request.eject(interceptor);
        };
    }, []);

    // Hàm gọi API đồng loạt để lấy số dư tất cả sảnh game và ví chính
    const fetchAllBalances = async () => {
        setIsGlobalLoading(true);
        
        // Cập nhật lại số dư ví chính
        if (getProfile) {
            getProfile();
        } else {
            axios.get(`${process.env.REACT_APP_API_URL}/auth/getUser`)
                .then(res => setLocalProfile(res.data.data))
                .catch(() => {});
        }
        
        // Lấy số dư từng sảnh
        const fetchBalance = async (lobby) => {
            try {
                const res = await axios.post(`${process.env.REACT_APP_API_URL}/casino/getbalance`, { product_type: lobby.code });
                return { ...lobby, balance: res.data.data.balance || 0, status: 'idle' };
            } catch (err) {
                return { ...lobby, balance: 0, status: 'idle' };
            }
        };

        // set lại trạng thái loading cho các sảnh để UI giật xoay xoay khi bấm nút Reload
        setLobbies(prev => prev.map(l => ({ ...l, status: 'loading' })));

        const results = await Promise.all(PROVIDERS.map(l => fetchBalance(l)));
        setLobbies(results);
        setIsGlobalLoading(false);
    };

    // Hàm rút tiền (thu hồi) từ MỘT sảnh duy nhất
    const handleWithdrawSingle = async (code, amount) => {
        if (amount <= 0) return;

        setLobbies(prev => prev.map(l => l.code === code ? { ...l, status: 'withdrawing' } : l));

        try {
            await axios.post(`${process.env.REACT_APP_API_URL}/casino/transfer`, {
                product_type: code,
                type: 2, 
                money: Math.floor(amount)
            });

            swal("Thành công", "Rút tiền về ví chính thành công!", "success");
            
            if (getProfile) getProfile();
            else fetchAllBalances(); // Refresh lại nếu không có hàm props
            
            setLobbies(prev => prev.map(l => l.code === code ? { ...l, balance: 0, status: 'idle' } : l));
        } catch (err) {
            swal("Thất bại", err.response?.data?.message || "Đã xảy ra lỗi khi rút tiền", "error");
            setLobbies(prev => prev.map(l => l.code === code ? { ...l, status: 'idle' } : l));
        }
    };

    // Hàm THU HỒI TẤT CẢ các sảnh có tiền
    const handleWithdrawAll = async () => {
        const lobbiesWithBalance = lobbies.filter(l => l.balance > 0);
        
        if (lobbiesWithBalance.length === 0) {
            swal("Thông báo", "Không có sảnh nào đang chứa số dư để thu hồi!", "info");
            return;
        }

        setIsGlobalLoading(true);
        let successCount = 0;

        for (const lobby of lobbiesWithBalance) {
            setLobbies(prev => prev.map(l => l.code === lobby.code ? { ...l, status: 'withdrawing' } : l));
            try {
                await axios.post(`${process.env.REACT_APP_API_URL}/casino/transfer`, {
                    product_type: lobby.code,
                    type: 2,
                    money: Math.floor(lobby.balance)
                });
                successCount++;
                setLobbies(prev => prev.map(l => l.code === lobby.code ? { ...l, balance: 0, status: 'idle' } : l));
            } catch (err) {
                setLobbies(prev => prev.map(l => l.code === lobby.code ? { ...l, status: 'idle' } : l));
            }
        }

        setIsGlobalLoading(false);
        if (getProfile) getProfile();
        else fetchAllBalances();

        if (successCount === lobbiesWithBalance.length) {
            swal("Thành công", "Đã thu hồi toàn bộ số dư các sảnh về ví chính!", "success");
        } else {
            swal("Hoàn tất", `Đã thu hồi thành công ${successCount}/${lobbiesWithBalance.length} sảnh có tiền.`, "warning");
        }
    };

    const currentProfile = getProfile ? profile : localProfile;

    return (
        <>
            <style>
                {`
                    .transfer-wrapper {
                        padding: 15px 25px;
                        background: #fff;
                        min-height: 100vh;
                        font-family: Arial, sans-serif;
                    }
                    .transfer-header-box {
                        position: relative;
                        text-align: center;
                        margin-bottom: 15px;
                        padding-top: 10px;
                    }
                    .text-red { color: #d32f2f; font-size: 16px; }
                    .text-blue { color: #007bff; font-weight: bold; font-size: 16px; }
                    
                    .btn-reload {
                        position: absolute;
                        right: 0;
                        top: 50%;
                        transform: translateY(-50%);
                        background: #f1f3f5;
                        border: 1px solid #ced4da;
                        color: #495057;
                        padding: 6px 12px;
                        border-radius: 4px;
                        cursor: pointer;
                        font-size: 13px;
                        font-weight: 600;
                        display: flex;
                        align-items: center;
                        gap: 5px;
                        transition: all 0.2s;
                    }
                    .btn-reload:hover { background: #e2e6ea; }
                    .btn-reload:disabled { opacity: 0.6; cursor: not-allowed; }

                    .btn-orange-gradient {
                        background: linear-gradient(180deg, #f09819 0%, #ed6a22 100%);
                        color: white;
                        border: none;
                        border-radius: 4px;
                        padding: 12px;
                        font-size: 15px;
                        font-weight: bold;
                        width: 100%;
                        cursor: pointer;
                        text-transform: uppercase;
                        margin-bottom: 25px;
                        box-shadow: 0 2px 4px rgba(0,0,0,0.2);
                        transition: opacity 0.2s;
                    }
                    .btn-orange-gradient:hover { opacity: 0.9; }
                    .btn-orange-gradient:disabled { opacity: 0.6; cursor: not-allowed; }

                    /* CHỈNH LẠI 4 Ô 1 DÒNG NHƯ YÊU CẦU */
                    .lobby-grid {
                        display: grid;
                        grid-template-columns: repeat(5, 1fr);
                        gap: 15px;
                    }
                    @media (max-width: 992px) {
                        .lobby-grid { grid-template-columns: repeat(3, 1fr); }
                    }
                    @media (max-width: 576px) {
                        .lobby-grid { grid-template-columns: repeat(2, 1fr); }
                    }

                    .lobby-card {
                        background: #ffffff;
                        border: 1px solid #e0e0e0;
                        border-radius: 6px;
                        padding: 15px 5px;
                        text-align: center;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                        min-height: 95px;
                    }
                    .lobby-title {
                        font-weight: bold;
                        color: #333;
                        font-size: 14px;
                        margin-bottom: 5px;
                    }
                    .lobby-amount {
                        font-weight: bold;
                        color: #000;
                        font-size: 15px;
                        margin-bottom: 5px;
                    }
                    .lobby-desc {
                        font-size: 12px;
                        color: #a0a0a0;
                    }
                    .btn-withdraw-small {
                        background: linear-gradient(180deg, #f09819 0%, #ed6a22 100%);
                        color: white;
                        border: none;
                        padding: 5px 15px;
                        border-radius: 3px;
                        font-size: 12px;
                        font-weight: bold;
                        cursor: pointer;
                        margin-top: 5px;
                    }
                    .btn-withdraw-small:disabled {
                        background: #ccc;
                        cursor: not-allowed;
                    }
                `}
            </style>

            {isGlobalLoading && (
                <div className="loading">
                    <div className="loader"></div>
                </div>
            )}

            <div className="transfer-wrapper">
                {currentProfile && (
                    <>
                        {/* Header: Số dư ví chính + Nút làm mới */}
                        <div className="transfer-header-box">
                            <span className="text-red">Số dư ví chính: </span>
                            <span className="text-blue">{currentProfile?.money?.toLocaleString("vi-VN")} VNĐ</span>
                            
                            <button 
                                className="btn-reload" 
                                onClick={fetchAllBalances}
                                disabled={isGlobalLoading}
                            >
                                ↻ Làm mới
                            </button>
                        </div>

                        {/* Nút THU HỒI TẤT CẢ */}
                        <button 
                            className="btn-orange-gradient"
                            onClick={handleWithdrawAll} 
                            disabled={isGlobalLoading} 
                        >
                            {isGlobalLoading ? "ĐANG XỬ LÝ..." : "THU HỒI TẤT CẢ VỀ VÍ CHÍNH"}
                        </button>

                        {/* DANH SÁCH SẢNH GAME (4 Ô 1 DÒNG) */}
                        <div className="lobby-grid">
                            {lobbies.map(lobby => (
                                <div key={lobby.code} className="lobby-card">
                                    <div className="lobby-title">{lobby.name}</div>
                                    
                                    {lobby.status === 'loading' ? (
                                        <div className="lobby-desc">Đang tải...</div>
                                    ) : (
                                        <>
                                            <div className="lobby-amount">
                                                {lobby.balance > 0 ? lobby.balance.toLocaleString("vi-VN") : "0"}
                                            </div>
                                            
                                            {lobby.balance > 0 ? (
                                                <button 
                                                    className="btn-withdraw-small"
                                                    onClick={() => handleWithdrawSingle(lobby.code, lobby.balance)}
                                                    disabled={lobby.status !== 'idle' || isGlobalLoading}
                                                >
                                                    {lobby.status === 'withdrawing' ? "Đang rút..." : "Thu hồi"}
                                                </button>
                                            ) : (
                                                <div className="lobby-desc">Không có số dư</div>
                                            )}
                                        </>
                                    )}
                                </div>
                            ))}
                        </div>
                    </>
                )}
            </div>
        </>
    );
}

export default Transfer;